import React from 'react';
import { Modal } from '@/design-system/Atoms/Modal';
import { type LegalContent } from '@/design-system/Atoms/Modal/modal.types';

interface LegalContentModalProps {
    isOpen: boolean;
    onClose: () => void;
    content: LegalContent;
}

const LegalContentModal: React.FC<LegalContentModalProps> = ({
    isOpen,
    onClose,
    content,
}) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={content.title}
            size="xl"
            className="max-h-[90vh]"
        >
            <div className="p-6">
                {/* {content.lastUpdated && (
                    <div className="mb-4 text-sm text-gray-600">
                        Last updated: {content.lastUpdated}
                    </div>
                )} */}
                <div className="prose prose-sm max-w-none">
                    {content.content()}
                </div>
            </div>
        </Modal>
    );
};

export default LegalContentModal;
